const CASHBACK_PROGRAM_STATUS_ENUM = {
  ACTIVE: 'active',
  SCHEDULED: 'scheduled',
  ENDED: 'ended',
};

export default CASHBACK_PROGRAM_STATUS_ENUM;
